import styled from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import { compose } from '../../node_modules/@styled-system/core/dist/index.esm.js';
import { space } from '../../node_modules/@styled-system/space/dist/index.esm.js';
import { layout } from '../../node_modules/@styled-system/layout/dist/index.esm.js';
import { border } from '../../node_modules/@styled-system/border/dist/index.esm.js';
import { position } from '../../node_modules/@styled-system/position/dist/index.esm.js';
import { shadow } from '../../node_modules/@styled-system/shadow/dist/index.esm.js';
var Img = styled.img(compose(space, layout, border, position, shadow));
export { Img };